module.exports = __webpack_public_path__ + "media/images/return-icon-2b447301d41d3e73fb7d83397e7eced2978eba2d951a2caea6a23ddd170465de.png";